<template>
  <div class="dialog-modal">
    <div class="move_dialog">
      <div class="dialog-head">移动文件</div>
      <div class="dialog-body">
        <Tree :pagetype="pagetype" @change="pathSelect"/>
      </div>
      <div class="dialog-foot">
        <w-button type="primary" @click.stop.prevent="affirm">确定</w-button>
        <w-button type="minor" @click.stop.prevent="cancel">取消</w-button>
        <!--<input class="ui-btn ui-btn_blue" @click="affirm" type="button" value="确定">-->
        <!--<input class="ui-btn" type="button"  @click="cancel" value="取消">-->
      </div>
    </div>
  </div>
</template>
<script>
import Tree from '_c/Space/Tree/Index.vue'
let path = ''
export default {
  components: {
    Tree
  },
  data () {
    return {

    }
  },
  props: {
    pagetype: {
      type: String
    }
  },
  methods: {
    pathSelect (val){
      path = val
    },
    affirm (){
      if (!path){
        return
      }
      this.$emit('affirm', path)
    },
    cancel (){
      this.$emit('cancel')
    }
  },

  created () {

  }
}
</script>
<style lang="less" scoped>
@import "./Index.less";
</style>

